<template>
  <section id="contact" class="section-padding bg-gray-50">
    <div class="container-custom">
      <div class="max-w-4xl mx-auto">
        <!-- Section Header -->
        <div class="text-center mb-16">
          <h2 
            class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 animate-fade-in"
          >
            {{ $t('contact.title') }}
          </h2>
          <h2 
            class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 animate-fade-in"
          >
            {{ $t('contact.title2') }}
          </h2>          
          <p 
            class="text-xl text-gray-600 max-w-3xl mx-auto mb-8 animate-slide-up"
            v-scroll-reveal="{ delay: 200 }"
          >
            {{ $t('contact.description') }}
          </p>
          <!-- <div 
            class="w-24 h-1 bg-gradient-to-r from-primary-600 to-accent-600 mx-auto animate-slide-up"
            v-scroll-reveal="{ delay: 400 }"
          ></div> -->
        </div>

        <!-- Contact Form -->
        <!-- <div class="bg-white rounded-2xl shadow-xl p-8">
          <form @submit.prevent="submitInquiry"> -->
            <!-- Form Title -->
            <!-- <h3 class="text-2xl font-bold text-gray-900 mb-8">
              {{ $t('contact.getQuote') }}
            </h3> -->

            <!-- Key Project Details -->
            <!-- <div class="mb-8">
              <h4 class="text-lg font-semibold text-gray-900 mb-4">
                {{ $t('contact.form.projectDetails') }}
              </h4> -->
              
              <!-- <div class="space-y-4"> -->
                <!-- Project Status -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    專案狀態 *
                  </label>
                  <select
                    v-model="formData.projectStatus"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="">請選擇</option>
                    <option value="planning">規劃中</option>
                    <option value="design">設計中</option>
                    <option value="ready">準備施工</option>
                    <option value="urgent">急需</option>
                  </select>
                </div> -->

                <!-- Location of Use -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    使用地點 *
                  </label>
                  <select
                    v-model="formData.locationType"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="">請選擇</option>
                    <option value="residential">住宅</option>
                    <option value="commercial">商業</option>
                    <option value="industrial">工業</option>
                    <option value="educational">教育</option>
                    <option value="public">公共空間</option>
                  </select>
                </div> -->

                <!-- Area to be shaded -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    遮陽面積 (m²) *
                  </label>
                  <select
                    v-model="formData.areaSize"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="">請選擇</option>
                    <option value="<20">< 20 m²</option>
                    <option value="20-50">20 - 50 m²</option>
                    <option value="50-100">50 - 100 m²</option>
                    <option value="100-200">100 - 200 m²</option>
                    <option value=">200">> 200 m²</option>
                  </select>
                </div> -->

                <!-- Desired completion date -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    期望完工日期 *
                  </label>
                  <select
                    v-model="formData.completionDate"
                    required
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="">請選擇</option>
                    <option value="asap">盡快</option>
                    <option value="1-month">1個月內</option>
                    <option value="2-3-months">2-3個月</option>
                    <option value="3-6-months">3-6個月</option>
                    <option value="flexible">彈性</option>
                  </select>
                </div> -->

                <!-- Location (ZIP, City, Country) -->
                <!-- <div class="grid grid-cols-3 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      郵遞區號
                    </label>
                    <input
                      v-model="formData.zipCode"
                      type="text"
                      placeholder="600"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    >
                  </div>
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      城市 *
                    </label>
                    <input
                      v-model="formData.city"
                      type="text"
                      required
                      placeholder="嘉義市"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    >
                  </div>
                </div> -->

                <!-- Type of Inquiry -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    詢問類型 *
                  </label>
                  <div class="flex space-x-4">
                    <label class="flex items-center flex-1 p-4 border-2 rounded-lg cursor-pointer transition-all"
                           :class="formData.inquiryType === 'consultation' ? 'border-primary-600 bg-primary-50' : 'border-gray-300 hover:border-primary-300'">
                      <input
                        type="radio"
                        v-model="formData.inquiryType"
                        value="consultation"
                        class="mr-3"
                        required
                      >
                      <span class="font-medium">諮詢</span>
                    </label>
                    <label class="flex items-center flex-1 p-4 border-2 rounded-lg cursor-pointer transition-all"
                           :class="formData.inquiryType === 'quote' ? 'border-primary-600 bg-primary-50' : 'border-gray-300 hover:border-primary-300'">
                      <input
                        type="radio"
                        v-model="formData.inquiryType"
                        value="quote"
                        class="mr-3"
                        required
                      >
                      <span class="font-medium">報價</span>
                    </label>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Personal Information -->
            <!-- <div class="mb-8">
              <h4 class="text-lg font-semibold text-gray-900 mb-4">
                {{ $t('contact.form.personalInfo') }}
              </h4>
              
              <div class="space-y-4"> -->
                <!-- First Name & Last Name -->
                <!-- <div class="grid grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('contact.form.firstName') }} *
                    </label>
                    <input
                      v-model="formData.firstName"
                      type="text"
                      required
                      placeholder="小明"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('contact.form.lastName') }} *
                    </label>
                    <input
                      v-model="formData.lastName"
                      type="text"
                      required
                      placeholder="王"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    >
                  </div>
                </div> -->

                <!-- Email -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    {{ $t('contact.form.email') }} *
                  </label>
                  <input
                    v-model="formData.email"
                    type="email"
                    required
                    placeholder="your.email@example.com"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                </div> -->

                <!-- Phone Number -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    {{ $t('contact.form.phone') }} *
                  </label>
                  <input
                    v-model="formData.phone"
                    type="tel"
                    required
                    placeholder="0912-345-678"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                </div> -->

                <!-- Message / Project Description -->
                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    {{ $t('contact.form.message') }}
                  </label>
                  <textarea
                    v-model="formData.message"
                    rows="5"
                    placeholder="請描述您的專案需求、預算範圍或任何相關資訊..."
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-none"
                  ></textarea>
                </div>
              </div>
            </div> -->

            <!-- Consent -->
            <!-- <div class="mb-8">
              <label class="flex items-start space-x-3 cursor-pointer">
                <input
                  v-model="formData.consent"
                  type="checkbox"
                  required
                  class="mt-1 w-5 h-5 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
                >
                <span class="text-sm text-gray-700">
                  {{ $t('contact.form.agree') }}
                  <a href="#privacy" class="text-primary-600 hover:underline">隱私政策</a>
                </span>
              </label>
            </div> -->

            <!-- Action Buttons -->
            <!-- <div class="flex flex-col sm:flex-row gap-4">
              <button
                type="button"
                @click="goToOnlineQuote"
                class="flex-1 bg-white text-black px-8 py-4 text-lg font-medium hover:bg-gray-100 transition-colors border border-gray-300"
              >
                在線估價
              </button>
              <button
                type="submit"
                :disabled="isSubmitting"
                class="flex-1 btn-primary text-lg py-4 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span v-if="!isSubmitting">{{ $t('contact.form.submit') }}</span>
                <span v-else class="flex items-center justify-center space-x-2">
                  <div class="spinner w-5 h-5"></div>
                  <span>{{ $t('contact.form.submitting') }}</span>
                </span>
              </button>
            </div>
          </form> -->

          <!-- Success Message -->
          <!-- <div
            v-if="showSuccessMessage"
            class="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start space-x-3"
          >
            <svg class="w-6 h-6 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div>
              <h4 class="font-semibold text-green-900">{{ $t('contact.form.success') }}</h4>
              <p class="text-sm text-green-700 mt-1">我們會盡快與您聯繫。</p>
            </div>
          </div> -->

          <!-- Error Message -->
          <!-- <div
            v-if="showErrorMessage"
            class="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3"
          >
            <svg class="w-6 h-6 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div>
              <h4 class="font-semibold text-red-900">{{ $t('contact.form.error') }}</h4>
              <p class="text-sm text-red-700 mt-1">請稍後再試或直接來電聯絡。</p>
            </div>
          </div>
        </div> -->
        <!-- Contact Form -->



      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/config/firebase'
import { useNotificationStore } from '@/stores/notification'
import { buildApiUrl, API_ENDPOINTS } from '@/config/api'

export default {
  name: 'ContactSection',
  setup() {
    const { t } = useI18n()
    const notificationStore = useNotificationStore()
    
    const isSubmitting = ref(false)
    const showSuccessMessage = ref(false)
    const showErrorMessage = ref(false)

    const formData = ref({
      projectStatus: '',
      locationType: '',
      areaSize: '',
      completionDate: '',
      zipCode: '',
      city: '',
      inquiryType: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: '',
      consent: false
    })

    // Submit inquiry form
    const submitInquiry = async () => {
      try {
        isSubmitting.value = true
        showSuccessMessage.value = false
        showErrorMessage.value = false

        console.log('開始提交詢問表單...', formData.value)

        // Send to backend API
        const response = await fetch(buildApiUrl(API_ENDPOINTS.INQUIRIES), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData.value)
        })

        console.log('API響應狀態:', response.status)

        if (!response.ok) {
          const errorData = await response.json()
          console.error('API錯誤:', errorData)
          throw new Error(errorData.error || '提交失敗')
        }

        const result = await response.json()
        console.log('提交成功:', result)

        // Show success message
        showSuccessMessage.value = true
        notificationStore.showSuccess(t('contact.form.success'))

        // Reset form
        resetForm()

      } catch (error) {
        console.error('提交詢問表單時發生錯誤:', error)
        showErrorMessage.value = true
        notificationStore.showError(t('contact.form.error'))
      } finally {
        isSubmitting.value = false
      }
    }

    // Reset form
    const resetForm = () => {
      formData.value = {
        projectStatus: '',
        locationType: '',
        areaSize: '',
        completionDate: '',
        zipCode: '',
        city: '',
        inquiryType: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
        consent: false
      }
    }

    // Go to online quote page
    const goToOnlineQuote = () => {
      window.location.href = '/quote'
    }

    // Scroll to section
    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId)
      if (element) {
        const headerHeight = 80
        const elementPosition = element.offsetTop - headerHeight

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        })
      }
    }

    // Initialize scroll animations
    onMounted(() => {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated')
          }
        })
      }, observerOptions)

      document.querySelectorAll('[v-scroll-reveal]').forEach(el => {
        observer.observe(el)
      })
    })

    return {
      formData,
      isSubmitting,
      showSuccessMessage,
      showErrorMessage,
      submitInquiry,
      goToOnlineQuote,
      scrollToSection
    }
  }
}
</script>

<style scoped>
/* Contact section specific styles */
.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0ea5e9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Form focus effects */
input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

/* Radio button custom styling */
input[type="radio"]:checked {
  background-color: #0ea5e9;
  border-color: #0ea5e9;
}

/* Checkbox custom styling */
input[type="checkbox"]:checked {
  background-color: #0ea5e9;
  border-color: #0ea5e9;
}

/* Hover effects */
.hover\:-translate-y-1:hover {
  transform: translateY(-0.25rem);
}

/* Social icons hover animation */
a[href]:hover svg {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>